/**
 * Personalization Script
 * Handles the visibility and validation of personalization fields.
 * Isolated to prevent conflicts with other scripts (like Patches).
 */
class PersonalizationManager {
    constructor() {
        this.active = false;
        this.containerId = 'aparecer';
        this.nameInputId = 'nomecamisa';
        this.numberInputId = 'numcamisa';
        this.detectSelector = '.detect_selected';

        this.init();
    }

    init() {
        console.log('PersonalizationManager: Initialized');
        // Initial check
        this.updateState();

        // Observer for text changes in the selected variant display
        const detectSelected = document.querySelector(this.detectSelector);
        if (detectSelected) {
            const observer = new MutationObserver(() => this.updateState());
            observer.observe(detectSelected, { childList: true, characterData: true, subtree: true });
        }

        // Event listener for clicks on variant selectors - USING DELEGATION
        document.addEventListener('click', (e) => this.handleVariantClick(e));

        // Event listener for changes on inputs - USING DELEGATION
        document.addEventListener('change', (e) => {
            if (e.target.matches('input[type="radio"]') || e.target.matches('select')) {
                console.log('PersonalizationManager: Input change detected');
                this.updateState();
            }
        });

        // Form submission validation
        document.addEventListener('submit', (e) => this.handleFormSubmit(e), true);

        // Input error clearing
        [this.nameInputId, this.numberInputId].forEach(id => {
            const el = document.getElementById(id);
            if (el) {
                el.addEventListener('input', function () { this.classList.remove('campo-erro'); });
            }
        });

        // Expose instance for debugging
        window.personalizationManager = this;
    }

    handleVariantClick(e) {
        console.log('PersonalizationManager: Click detected', e.target);
        const target = e.target;

        // CRITICAL: Ignore clicks within the patch section to prevent conflicts
        if (target.closest('.patch-section-wrapper') || target.closest('.patch-section-header')) {
            console.log('PersonalizationManager: Ignoring click from patch section');
            return;
        }

        const label = target.closest('label');
        const input = target.closest('input[type="radio"]');

        if (label || input) {
            console.log('PersonalizationManager: Variant option clicked');
            // Reduced delay to improve responsiveness
            setTimeout(() => this.updateState(), 100);
        }
    }

    checkVisibility() {
        // 1. Check radio buttons directly (Source of Truth - Immediate)
        const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');
        for (const radio of checkedRadios) {
            const val = radio.value.toLowerCase();
            console.log('PersonalizationManager: Checking radio value:', val);

            // STRICT CHECK: If it contains "não" or "nao", it is NOT personalization
            if (val.includes('não') || val.includes('nao')) {
                return false;
            }

            // If it contains "personalizar" OR is "sim" (and we passed the "não" check), it IS personalization
            if (val.includes('personalizar') || val === 'sim') {
                return true;
            }
        }

        // 2. Check text content of the display element (Fallback - might be stale)
        const el = document.querySelector(this.detectSelector);
        if (el) {
            const txt = el.textContent.trim().toLowerCase();
            console.log('PersonalizationManager: Checking text content:', txt);

            // STRICT CHECK: If it contains "não" or "nao", it is NOT personalization
            if (txt.includes('não') || txt.includes('nao')) return false;

            // If it contains "personalizar" OR is "sim" (and we passed the "não" check), it IS personalization
            if (txt.includes('personalizar') || txt === 'sim') return true;
        } else {
            console.warn('PersonalizationManager: Detect selector not found:', this.detectSelector);
        }

        return this.active; // Fallback to current state
    }

    updateState() {
        console.log('PersonalizationManager: Updating state...');
        const shouldBeActive = this.checkVisibility();
        console.log('PersonalizationManager: Should be active?', shouldBeActive);
        if (shouldBeActive) {
            this.show();
        } else {
            this.hide();
        }
    }
    show() {
        const container = document.getElementById(this.containerId);
        if (!container || this.active) return;

        this.active = true;
        container.style.display = 'block';

        const nameInput = document.getElementById(this.nameInputId);
        const numInput = document.getElementById(this.numberInputId);
        if (nameInput) nameInput.required = true;
        if (numInput) numInput.required = true;
    }
    hide() {
        const container = document.getElementById(this.containerId);
        if (!container || !this.active) return;

        this.active = false;
        container.style.display = 'none';

        const nameInput = document.getElementById(this.nameInputId);
        const numInput = document.getElementById(this.numberInputId);

        if (nameInput) {
            nameInput.required = false;
            nameInput.value = '';
            nameInput.classList.remove('campo-erro');
        }
        if (numInput) {
            numInput.required = false;
            numInput.value = '';
            numInput.classList.remove('campo-erro');
        }
    }







    

    handleFormSubmit(e) {
        if (!this.active) return;

        const form = e.target;
        // Ensure we are submitting a product form
        if (!form || !form.getAttribute('id') || form.getAttribute('id').indexOf('product-form') === -1) return;

        const nameInput = document.getElementById(this.nameInputId);
        const numInput = document.getElementById(this.numberInputId);

        if (!nameInput || !numInput) return;

        if (!nameInput.value.trim() || !numInput.value.trim()) {
            e.preventDefault();
            e.stopPropagation(); // Stop other listeners

            nameInput.classList.toggle('campo-erro', !nameInput.value.trim());
            numInput.classList.toggle('campo-erro', !numInput.value.trim());

            alert('Por favor, preencha os campos de personalização!');
            return false;
        }
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new PersonalizationManager());
} else {
    new PersonalizationManager();
}
